import React, { Fragment, PureComponent } from "react";
import { UISref } from "@uirouter/react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { getNotificationsSelector } from "../../selectors/selectors";
import { getUserName } from "../../helpers/userHelpers";
import { hasUserAtLeastOneRole } from "../../helpers/Authorization/authorizationHelpers";
import BrowserWarning from "./BrowserWarning";
import { updateUserMetadata } from "../../actions";
import KTrackLogo from "../../assets/K-Trak_Logo.png";
import NotificationBell from "./Notifications/NotificationBell";
import SettingsDropDown from "./SettingsDropDown";

class Navbar extends PureComponent {
  static propTypes = {
    updateUserMetadata: PropTypes.func.isRequired,
    className: PropTypes.string,
    isAuthenticated: PropTypes.bool,
    isMobile: PropTypes.bool,
    notifications: PropTypes.array,
    pictureSrc: PropTypes.string,
    user: PropTypes.object,
    userMetadata: PropTypes.object,
    userName: PropTypes.string
  };

  static defaultProps = {
    className: "",
    isAuthenticated: false,
    isMobile: false,
    notifications: [],
    pictureSrc: "",
    userMetadata: {},
    userName: ""
  };

  handleLanguageChange = () => {
    const language = this.props.userMetadata.language === "fr" ? "en" : "fr";
    this.props.updateUserMetadata({ ...this.props.userMetadata, ...{ language } }, this.props.user.sub);
  };

  render() {
    const hasAtLeastOneRole = hasUserAtLeastOneRole();

    return (
      <header role="banner" className={classNames("navbar", this.props.className)}>
        <div className="navbar__content --start">
          <UISref to="home">
            <figure className="navbar__home" role="presentation">
              <img src={KTrackLogo} alt="logo kruger" className="navbar__logo" />
            </figure>
          </UISref>
        </div>

        <div className="navbar__content --end --menu">
          {hasAtLeastOneRole && (
            <Fragment>
              <button className="navbar__links" onClick={this.handleLanguageChange}>
                {i18n.t("navbar.language")}
              </button>
              <UISref to="advanced-search">
                <a className="navbar__links">{i18n.t("navbar.advancedSearch")}</a>
              </UISref>
              <UISref to="contact-us">
                <a className="navbar__links">{i18n.t("navbar.contactUs")}</a>
              </UISref>
              <div className="navbar__links">
                <NotificationBell isMobile={this.props.isMobile} notifications={this.props.notifications} userMetadata={this.props.userMetadata} />
              </div>
            </Fragment>
          )}
          <div className="navbar__links">
            <SettingsDropDown isAuthenticated={this.props.isAuthenticated} pictureSrc={this.props.pictureSrc} userName={this.props.userName} />
          </div>
        </div>
        <BrowserWarning />
      </header>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.app.isAuthenticated,
    isMobile: state.app.isMobile,
    notifications: getNotificationsSelector(state),
    pictureSrc: state.app.user.picture,
    userName: getUserName(state.app.user),
    user: state.app.user,
    userMetadata: state.app.userMetadata
  };
};

export default connect(
  mapStateToProps,
  { updateUserMetadata }
)(Navbar);



// WEBPACK FOOTER //
// ./src/components/Layout/Navbar.js